module.exports = __webpack_public_path__ + "static/media/white-tower.f5a541c0.svg";